<template>
  <q-layout view="lHh Lpr lFf">
    <q-header elevated class="bg-blue7">
      <q-toolbar>
        <q-btn
          flat
          dense
          round
          aria-label="Menu"
          icon="menu"
          @click="leftDrawerOpen = !leftDrawerOpen"
        />
        <q-toolbar-title>Dyt. Gizem Eti</q-toolbar-title>
      </q-toolbar>
    </q-header>

    <q-drawer v-model="leftDrawerOpen" show-if-above bordered class="bg-grey-2">
      <SidebarList />
    </q-drawer>

    <q-footer elevated>
      <q-toolbar class="bg-blue7">
        <q-toolbar-title
          >© {{ year }} |
          <span class="text-subtitle2 text-italic text-weight-light">
            {{ timestamp }}</span
          >
        </q-toolbar-title>
      </q-toolbar>
    </q-footer>

    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>
import { ref } from 'vue'
import moment from 'moment'
import SidebarList from './components/SidebarList.vue'
export default {
  name: 'LayoutDefault',
  components: { SidebarList },
  setup() {
    const timestamp = ref({})
    const year = ref({})

    setInterval(() => {
      timestamp.value = moment().format('dddd, MMMM Do, HH:mm:ss')
      year.value = moment().format('YYYY')
    }, 1000)

    return {
      timestamp,
      year,
      leftDrawerOpen: ref(false),
    }
  },
}
</script>
